import { css } from '@emotion/core'
import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getLastPathElement } from '../../../../../util/StringUtil'
import ActionButton from '../helpers/ActionButton'
import DetailHeader from '../helpers/DetailHeader'
import HiddenDetails from '../helpers/HiddenDetails'
import ItemBlock from '../helpers/ItemBlock'

const smallFont = css`
  font-size: 12px;
`
const mediumFont = css`
  font-size: 14px;
`
const hide = css`
  visibility: hidden;
`

export default function Vitals({ person, actionButtonOnClick, toggleShowItemHiddenDetails }) {
  const { t } = useTranslation()
  const actionButtonOnClickVital = (item) => {
    actionButtonOnClick({ item, actionButtonType: person.vitals[item.toLowerCase()].actionButtonType })
  }
  return (
    <>
      <ItemBlock
        selected={person.vitals.name.actionButtonType === 'UNDO'}
        displayStatus={person.vitals.name.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <Vital
          person={person}
          label={t('name', 'Name')}
          conclusion={person.vitals.name.value}
          showHiddenDetails={person.vitals.name.showHiddenDetails}
          actionButtonType={person.vitals.name.actionButtonType}
          toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Name' })}
          actionButtonOnClick={() => actionButtonOnClickVital('Name')}
        />
      </ItemBlock>
      <ItemBlock
        selected={person.vitals.sex.actionButtonType === 'UNDO'}
        displayStatus={person.vitals.sex.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <Vital
          person={person}
          label={t('sex', 'Sex')}
          conclusion={person.vitals.sex.value}
          showHiddenDetails={person.vitals.sex.showHiddenDetails}
          actionButtonType={person.vitals.sex.actionButtonType}
          toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Sex' })}
          actionButtonOnClick={() => actionButtonOnClickVital('Sex')}
        />
      </ItemBlock>
      <ItemBlock
        selected={person.vitals.birth.actionButtonType === 'UNDO'}
        displayStatus={person.vitals.birth.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <Vital
          person={person}
          label={t('birth', 'Birth')}
          conclusion={person.vitals.birth.value}
          showHiddenDetails={person.vitals.birth.showHiddenDetails}
          actionButtonType={person.vitals.birth.actionButtonType}
          toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Birth' })}
          actionButtonOnClick={() => actionButtonOnClickVital('Birth')}
        />
      </ItemBlock>
      <ItemBlock
        selected={person.vitals.christening.actionButtonType === 'UNDO'}
        displayStatus={person.vitals.christening.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <Vital
          person={person}
          label={t('christening', 'Christening')}
          conclusion={person.vitals.christening.value}
          showHiddenDetails={person.vitals.christening.showHiddenDetails}
          actionButtonType={person.vitals.christening.actionButtonType}
          toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Christening' })}
          actionButtonOnClick={() => actionButtonOnClickVital('Christening')}
        />
      </ItemBlock>
      <ItemBlock
        selected={person.vitals.death.actionButtonType === 'UNDO'}
        displayStatus={person.vitals.death.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <Vital
          person={person}
          label={t('death', 'Death')}
          conclusion={person.vitals.death.value}
          showHiddenDetails={person.vitals.death.showHiddenDetails}
          actionButtonType={person.vitals.death.actionButtonType}
          toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Death' })}
          actionButtonOnClick={() => actionButtonOnClickVital('Death')}
        />
      </ItemBlock>
      <ItemBlock
        selected={person.vitals.burial.actionButtonType === 'UNDO'}
        displayStatus={person.vitals.burial.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <Vital
          person={person}
          label={t('burial', 'Burial')}
          conclusion={person.vitals.burial.value}
          showHiddenDetails={person.vitals.burial.showHiddenDetails}
          actionButtonType={person.vitals.burial.actionButtonType}
          toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Burial' })}
          actionButtonOnClick={() => actionButtonOnClickVital('Burial')}
        />
      </ItemBlock>
    </>
  )
}

function Vital({
  person,
  label,
  conclusion,
  showHiddenDetails,
  actionButtonType,
  toggleShowItemHiddenDetails,
  actionButtonOnClick,
}) {
  const { t } = useTranslation()
  let data = null
  if (label === 'Birth' || label === 'Death' || label === 'Christening' || label === 'Burial') {
    data = (
      <span css={mediumFont}>
        {conclusion?.value?.date?.normalized?.[0]?.value
          ? conclusion?.value?.date?.normalized?.[0]?.value
          : conclusion?.value?.date?.original}
        {!conclusion.value.date && label === 'Death' ? (
          t('deceased', `Deceased`)
        ) : (
          <span css={hide}>{t('noDate', 'No Date')}</span>
        )}
        <br />
        {conclusion?.value?.place?.names?.[0]?.value
          ? conclusion?.value?.place?.names?.[0]?.value
          : conclusion?.value?.place?.original}
        {!conclusion.value.place && <span css={hide}>{t('noPlace', 'No Place')}</span>}
      </span>
    )
  } else if (label === 'Name') {
    data = (
      <>
        <div css={smallFont}>{t('birthName', 'Birth Name')}</div>
        {conclusion?.value?.nameForms?.[0]?.fullText}
      </>
    )
  } else if (label === 'Sex') {
    data = getLastPathElement(conclusion?.value?.type)
  }
  return (
    <>
      <DataBlock
        heading={
          <DetailHeader
            heading={label}
            showHiddenDetails={showHiddenDetails}
            toggleShowItemHiddenDetails={toggleShowItemHiddenDetails}
          />
        }
        data={data}
      />
      <HiddenDetails person={person} conclusion={conclusion} showHiddenDetails={showHiddenDetails} />
      <ActionButton type={actionButtonType} onClick={actionButtonOnClick} />
    </>
  )
}
